import * as React from "react";
import { CourseResource } from "../../../../../stores/CoursesStore/Types";

interface Props {
  courseResource: CourseResource;
}

const Rating: React.FC<Props> = ({ courseResource }) => {
  const fullStars = Math.round(courseResource.rating);
  const displayedRating = fullStars.toFixed(1);

  if (courseResource.content_version == "upcoming") {
    return (
      <h5
        className={`${
          courseResource.enrolled_student_present ? "enrolled" : ""
        }`}
      >
        Coming {courseResource.course_release_date}
      </h5>
    );
  }

  return (
    <div
      className={`rating-info ${
        courseResource.enrolled_student_present ? "enrolled" : ""
      }`}
    >
      <div className="stars" aria-label={`Rated ${displayedRating} out of 5`}>
        {"★".repeat(1)}
        <span>{Number(courseResource?.rating || 0).toFixed(1)}</span>
      </div>
    </div>
  );
};

export default Rating;
